<template>
  <modal-layout :is-open="isOpen" @close="modalClose">
    <div class="Modal_area">
      <div class="Modal_title">
        グラフの活用法
      </div>
      <div
        class="Modal__cross-box _cross"
        role="button"
        tabindex="0"
        aria-label="ログを記録モーダルを閉じる"
        @click="modalClose"
      >
        <span class="Modal__cross" />
      </div>
      <div class="Modal_inner">
        <div class="LogRecord__modal">
          <div class="LogRecord__modal_howto">
            <div class="LogRecord__modal_howto_tx_area">
              <p class="LogRecord__modal_howto_tx">
                マインドフルネスは始めて2ヶ月くらいから<br class="_dsp-none--sp">
                効果が実感できるとされています。
              </p>
              <p class="LogRecord__modal_howto_tx">
                継続した時、心の状態や体調がどのように<br class="_dsp-none--sp">
                変化するか観察してみてください。
              </p>
              <p class="LogRecord__modal_howto_tx">
                すでにマインドフルネスを実践している方も、<br class="_dsp-none--sp">
                これから2ヶ月間を観察強化月間としてみませんか？
              </p>
            </div>
          </div>
        </div>
        <div class="LogRecord__modal_btn_area">
          <div class="LogRecord__modal_btn ft_en _hover_pt01 _cross" @click="modalClose">
            OK
          </div>
        </div>
      </div>
    </div>
  </modal-layout>
</template>
<script>
import ModalLayout from '@/views/components/modals/ModalLayout.vue'
export default {
  name: 'LogGraphModal',
  components: { ModalLayout },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    modalClose() {
      this.$emit('close')
    }
  }
}
</script>
